function normalizeLocale(locale) {
  return locale.replace('_', '-');
}

// https://stackoverflow.com/questions/53382465/how-can-i-determine-if-week-starts-on-monday-or-sunday-based-on-locale-in-pure-j
// TODO: This could properly be optimized and made more readable
function weekStart(region, language) {
  var regionSat = 'AEAFBHDJDZEGIQIRJOKWLYOMQASDSY'.match(/../g);
  var regionSun = 'AGARASAUBDBRBSBTBWBZCACNCODMDOETGTGUHKHNIDILINJMJPKEKHKRLAMHMMMOMTMXMZNINPPAPEPHPKPRPTPYSASGSVTHTTTWUMUSVEVIWSYEZAZW'.match(/../g);
  var languageSat = ['ar', 'arq', 'arz', 'fa'];
  var languageSun = 'amasbndzengnguhehiidjajvkmknkolomhmlmrmtmyneomorpapssdsmsnsutatethtnurzhzu'.match(/../g);
  return region ? regionSun !== null && regionSun !== void 0 && regionSun.includes(region) ? 0 : regionSat !== null && regionSat !== void 0 && regionSat.includes(region) ? 6 : 1 : languageSun !== null && languageSun !== void 0 && languageSun.includes(language) ? 0 : languageSat.includes(language) ? 6 : 1;
}
function weekDays(locale, format) {
  locale = normalizeLocale(locale);
  var baseDate = new Date(Date.UTC(2020, 7, 2)); // a sunday
  var weekDays = [];
  for (var i = 0; i < 7; i++) {
    weekDays.push(baseDate.toLocaleDateString(locale, {
      weekday: format
    }));
    baseDate.setDate(baseDate.getDate() + 1);
  }
  return weekDays;
}
function months(locale, format) {
  locale = normalizeLocale(locale);
  var baseDate = new Date(Date.UTC(2020, 0, 1));
  var months = [];
  for (var i = 0; i < 12; i++) {
    months.push(baseDate.toLocaleDateString(locale, {
      month: format
    }));
    baseDate.setMonth(baseDate.getMonth() + 1);
  }
  return months;
}
function localeParts(locale) {
  var _r$exec;
  locale = normalizeLocale(locale);
  var r = new RegExp('^([a-z]{2,3})(?:-([a-z]{3})(?=$|-))?(?:-([a-z]{4})(?=$|-))?(?:-([a-z]{2}|d{3})(?=$|-))?', 'i');
  var parts = (_r$exec = r.exec(locale)) !== null && _r$exec !== void 0 ? _r$exec : [];
  return [parts[4], parts[1]];
}

/**
 * Returns the weekStart for a given locale
 */
export function weekStartLocale(locale) {
  var parts = localeParts(locale);
  return weekStart(parts[0], parts[1]);
}

/**
 * Returns an array of weekdays names in long format starting from sunday
 */
export function weekDaysLong(locale) {
  return weekDays(locale, 'long');
}

/**
 * Returns an array of weekdays names in short (abbreviated) format starting from sunday
 */
export function weekDaysShort(locale) {
  return weekDays(locale, 'short');
}
export function monthsLong(locale) {
  return months(locale, 'long');
}